import React, { useEffect, useState } from 'react';
import { BiSend } from 'react-icons/bi';
import { CgLock } from 'react-icons/cg';
import {  FaMailBulk, FaPhone } from 'react-icons/fa';
import LifeAtAD from '../Images/LifeAtAD.jpg';
import UrlTag from '../components/UrlTag';
import { HiOutlineMapPin } from 'react-icons/hi2';

const ContactPage = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const redirectToHome = () => {
        setIsSubmitted(false);
        setIsLoading(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData(event.target);
            const response = await fetch(
                'https://docs.google.com/forms/d/e/1FAIpQLSe2wmq5jEjxWtnmadOWNBpJe-8bZLJo29VFG_7UjoHDT_H1rA/formResponse',
                {
                    method: 'POST',
                    body: formData,
                    mode: 'no-cors'
                }
            );
            console.log(response);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    // const socialLinks = [
    //     {
    //         icon: <FaInstagram className="w-6 h-6" />,
    //         url: "https://www.instagram.com/architetivedesigns?igsh=MTV4eGIyeTlreGZ0cQ==",
    //         color: "hover:bg-gradient-to-tr from-[#fdbf60] via-[#d72c78] to-[#9034b5]"
    //     },
    //     {
    //         icon: <FaFacebook className="w-6 h-6" />,
    //         url: "https://www.facebook.com/share/1Aqcj3DFFa/",
    //         color: "hover:bg-blue-600"
    //     },
    //     {
    //         icon: <FaLinkedin className="w-6 h-6" />,
    //         url: "https://www.linkedin.com/in/architetive-designs-18279934a",
    //         color: "hover:bg-blue-700"
    //     },
    //     {
    //         icon: <FaYoutube className="w-6 h-6" />,
    //         url: "https://www.youtube.com/channel/UC7a1glo22K08gE_GGxP3oqQ",
    //         color: "hover:bg-red-600"
    //     },
    //     {
    //         icon: <FaTwitter className="w-6 h-6" />,
    //         url: "https://x.com/ArchitetiveD",
    //         color: "hover:bg-blue-400"
    //     }
    // ];

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
            <UrlTag />
            <div className="relative">
                <img src={LifeAtAD} alt="Life at Architetive Designs" className="w-full h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-4xl font-bold">Contact</h1>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 py-16">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="space-y-6 flex flex-col p-4 bg-white justify-center shadow-lg rounded-3xl">
                        <div className="border rounded-lg p-6">
                            <div className="flex items-center space-x-4">
                                <div className="p-3 bg-slate-200 rounded-lg">
                                    <HiOutlineMapPin className="w-6 h-6 text-[#333333]" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">Visit Us</h3>
                                    <a href="https://www.google.com/maps/place/Architetive+designs/@26.6207791,92.7943338,20.75z/data=!4m9!1m2!2m1!1stezpur+ganesh+ghat!3m5!1s0x3744e9ee90308de5:0xa05cc69e85c0d35d!8m2!3d26.6208151!4d92.7946191!16s%2Fg%2F11s2pwpndb?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D" target='blank'>
                                        <p className="text-gray-600 mt-1">Tezpur, Assam, India</p>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="rounded-lg border p-6">
                            <div className="flex items-center space-x-4">
                                <div className="p-3 bg-slate-200 rounded-lg">
                                    <FaPhone className="w-6 h-6 text-[#333333]" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">Call Us</h3>
                                    <a href="tel:+917099020826">
                                        <p className="text-gray-600 mt-1">+91 70990 20826</p>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="rounded-lg border p-6">
                            <div className="flex items-center space-x-4">
                                <div className="p-3 bg-slate-200 rounded-lg">
                                    <FaMailBulk className="w-6 h-6 text-[#333333]" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">Email Us</h3>
                                    <a href="mailto:info@architetivedesigns.com">
                                        <p className="text-gray-600 mt-1">info@architetivedesigns.com</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="rounded-lg border p-6">
                            <div className="flex items-center space-x-4">
                                <div className="p-3 bg-slate-200 rounded-lg">
                                    <CgLock className="w-6 h-6 text-[#333333]" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">Business Hours</h3>
                                    <p className="text-gray-600 mt-1">Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 2:00 PM</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="h-full flex items-center justify-center bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-2xl p-10 overflow-hidden">
                            {!isSubmitted ? (
                                <div className="w-full">
                                    <div className="mb-12 text-center">
                                        <h2 className="text-3xl font-bold text-gray-900 mb-3">Get in Touch</h2>
                                        <p className="text-gray-600">We'd love to hear from you. Send us a message.</p>
                                    </div>

                                    <form onSubmit={handleSubmit} className="space-y-8">
                                        <div>
                                            <input
                                                type="text"
                                                name="entry.750446566"
                                                required
                                                placeholder="Full Name *"
                                                className="w-full bg-white/80 backdrop-blur-sm px-4 py-4 rounded-xl border border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-200 placeholder-gray-400"
                                            />
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                            <div>
                                                <input
                                                    type="tel"
                                                    name="entry.1504991422"
                                                    required
                                                    placeholder="Phone Number *"
                                                    className="w-full px-4 py-4 rounded-xl border border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-200 placeholder-gray-400"
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    type="email"
                                                    name="entry.711929505"
                                                    placeholder="Email"
                                                    className="w-full bg-white/80 backdrop-blur-sm px-4 py-4 rounded-xl border border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-200 placeholder-gray-400"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <input
                                                type="text"
                                                name="entry.2126687868"
                                                required
                                                placeholder="Address *"
                                                className="w-full bg-white/80 backdrop-blur-sm px-4 py-4 rounded-xl border border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-200 placeholder-gray-400"
                                            />
                                        </div>

                                        <div>
                                            <textarea
                                                name="entry.1363248822"
                                                placeholder="Requirements (if any)"
                                                className="w-full bg-white/80 backdrop-blur-sm px-4 py-4 rounded-xl border border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-200 placeholder-gray-400"
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="w-full bg-[#333333] text-white px-8 py-4 rounded-xl font-medium flex items-center justify-center space-x-2 transition-all duration-200 shadow-lg shadow-[#333333]/25 hover:shadow-xl transform hover:-translate-y-0.5"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <span>Submitting...</span>
                                            ) : (
                                                <>
                                                    <BiSend className="w-5 h-5" />
                                                    <span>Send Message</span>
                                                </>
                                            )}
                                        </button>
                                    </form>
                                </div>
                            ) : (
                                <div className="p-8 text-center flex flex-col items-center justify-center">
                                    <div className="mb-6">
                                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                            </svg>
                                        </div>
                                        <h2 className="text-2xl font-bold text-gray- 900 mb-2">Thank You for Reaching Out!</h2>
                                        <p className="text-gray-600 text-sm">
                                            We have received your request and appreciate you contacting us. Our team will get back to you shortly.
                                        </p>
                                    </div>
                                    <button
                                        onClick={redirectToHome}
                                        className="bg-[#333333] text-white py-2 px-6 rounded-full hover:opacity-90 transition-colors"
                                    >
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* <div className="mt-16 bg-white rounded-3xl shadow-lg p-8">
                    <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">Connect With Us</h2>
                    <div className="flex items-center justify-center space-x-6">
                        {socialLinks.map((social, index) => (
                            <a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`
                                    transform transition-all duration-300
                                    p-4 rounded-full
                                    text-gray-600 
                                    ${social.color}
                                    hover:text-white
                                    hover:scale-110
                                    hover:shadow-lg
                                    bg-gray-100
                                `}
                            >
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default ContactPage;